import { render, staticRenderFns } from "./RangeCriterion.vue?vue&type=template&id=3d554f40&"
import script from "./RangeCriterion.vue?vue&type=script&lang=js&"
export * from "./RangeCriterion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports